import jsPDF from "jspdf";

interface PostcardRecord {
  documentType?: string;
  county?: string;
  businessName?: string;
  recordedDate?: string;
}

export function generatePostcardPdf(records: PostcardRecord[]): void {
  // 4x6 postcard in landscape: 6 wide x 4 tall
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "in",
    format: [4, 6],
  });

  records.forEach((record, idx) => {
    if (idx > 0) doc.addPage([4, 6], "landscape");

    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);

    const topStart = 0.95;
    const lineSpacing = 0.18;
    const rightMargin = 5.75; // 0.25" from right edge of 6" card

    const lines = [
      record.documentType || "Land Contract",
      record.county || "",
      record.businessName || "",
      `Recorded ${record.recordedDate || ""}`,
    ];

    // Find the widest line and position left so it fits within the right margin
    const maxWidth = Math.max(...lines.map((l) => doc.getTextWidth(l)));
    const left = Math.max(0.25, rightMargin - maxWidth);

    lines.forEach((line, i) => {
      doc.text(line, left, topStart + i * lineSpacing);
    });
  });

  doc.save(`Postcards_${new Date().toISOString().split("T")[0]}.pdf`);
}
